import React, { useEffect, useState } from 'react';
import axios from 'axios';

const PlatformAdminSellerAdd = () => {
  const [loading, setLoading] = useState(true);
  const [csrf, setCsrf] = useState('');
  const [error, setError] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);

      const res = await axios.get('/api/platform_admin/seller_add', {
        withCredentials: true,
      });

      if (res.data && res.data.ok) {
        setCsrf(res.data.csrf || '');
        setError(res.data.error || '');
        setUsername(res.data.username || '');
      } else if (res.data && res.data.redirect) {
        window.location.href = res.data.redirect;
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        const redirectUrl =
          err.response.data && err.response.data.redirect
            ? err.response.data.redirect
            : '/platform_admin/login';
        window.location.href = redirectUrl;
        return;
      }

      console.error('셀러 추가 화면 로드 실패:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.get('/api/platform_admin/logout', {
        withCredentials: true,
      });

      if (res.data && res.data.ok && res.data.redirect) {
        window.location.href = res.data.redirect;
        return;
      }

      window.location.href = '/platform_admin/login';
    } catch (err) {
      console.error('로그아웃 실패:', err);
      window.location.href = '/platform_admin/login';
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new URLSearchParams();
      formData.append('csrf_token', csrf);
      formData.append('username', username);
      formData.append('password', password);

      const res = await axios.post('/api/platform_admin/seller_add', formData, {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (res.data && res.data.ok && res.data.redirect) {
        window.location.href = res.data.redirect;
        return;
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        const redirectUrl =
          err.response.data && err.response.data.redirect
            ? err.response.data.redirect
            : '/platform_admin/login';
        window.location.href = redirectUrl;
        return;
      }

      if (err.response && err.response.data) {
        setError(err.response.data.error || err.response.data.msg || '');
        if (typeof err.response.data.csrf !== 'undefined') {
          setCsrf(err.response.data.csrf || '');
        }
        if (typeof err.response.data.username !== 'undefined') {
          setUsername(err.response.data.username || '');
        }
        return;
      }

      console.error('셀러 추가 실패:', err);
      setError('오류가 발생했습니다.');
    }
  };

  return (
    <div className="bg-light min-vh-100">
      <nav className="navbar navbar-dark bg-dark px-4">
        <span className="navbar-brand">플랫폼 관리자</span>
        <div>
          <a href="/platform_admin/sellers" className="btn btn-sm btn-outline-light me-2">
            셀러관리
          </a>
          <a href="/platform_admin/shops" className="btn btn-sm btn-outline-light me-2">
            상점관리
          </a>
          <a href="/platform_admin/orders" className="btn btn-sm btn-outline-light me-2">
            주문관리
          </a>
          <a href="/platform_admin/claims" className="btn btn-sm btn-outline-light me-2">
            클레임
          </a>
          <a href="/platform_admin/notices" className="btn btn-sm btn-outline-light me-2">
            공지관리
          </a>
          <a href="/platform_admin/logout" onClick={handleLogout} className="btn btn-sm btn-danger">
            로그아웃
          </a>
        </div>
      </nav>

      <div className="container my-4">
        <h4 className="mb-3">➕ 새 셀러 추가</h4>

        {error ? <div className="alert alert-danger">{error}</div> : null}

        <div className="card shadow-sm">
          <div className="card-body">
            {loading ? (
              <div className="text-center py-4 text-muted">불러오는 중...</div>
            ) : (
              <form onSubmit={handleSubmit}>
                <input type="hidden" name="csrf_token" value={csrf} />

                <div className="mb-3">
                  <label className="form-label">사용자명 (username)</label>
                  <input
                    type="text"
                    name="username"
                    className="form-control"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">비밀번호</label>
                  <input
                    type="password"
                    name="password"
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>

                <div className="d-flex justify-content-end gap-2">
                  <a href="/platform_admin/sellers" className="btn btn-secondary">
                    취소
                  </a>
                  <button type="submit" className="btn btn-success">
                    추가
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformAdminSellerAdd;